export default (function (siteVariables) {
  return {
    borderColor: undefined,
    borderWidth: 2,
    successBackgroundColor: siteVariables.colors.green[200],
    successTextColor: siteVariables.colors.white,
    infoBackgroundColor: siteVariables.colors.brand[500],
    infoTextColor: siteVariables.colors.white,
    warningBackgroundColor: siteVariables.colors.yellow[400],
    warningTextColor: siteVariables.colors.white,
    errorBackgroundColor: siteVariables.colors.red[400],
    errorTextColor: siteVariables.colors.white,
    defaultBackgroundColor: siteVariables.colors.grey[350],
    defaultTextColor: siteVariables.colors.white
  };
});